import { PropsWithChildren, memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { DateTimePickerInputs, FormRow } from '@features/components/CaseFormBlocks/components';
import { ConditionalRender } from '@ui';
import { ServiceType } from '@/api/apis/case';
import { CaseTxCenterBanners, CaseTxContacts, TxCenterSelector } from './components';
import { CaseTxCenterFormType } from '../CaseOverview/components/Tabs/CaseDetails/components/EditCaseForms/EditCaseTxCenter/config';

type TxDisabledState = {
  txCenterId?: boolean;
  txCenterAddress?: boolean;
};

type CaseTxCenterProps = {
  showRequired?: boolean;
  disabled?: TxDisabledState;
  hasPermission?: boolean;
  txUserDisabled?: boolean;
  showTxCenterORDateTimeFields?: boolean;
  showWarningNotification?: boolean;
  serviceType?: ServiceType;
} & PropsWithChildren;

export const CaseTxCenter = memo(
  ({
    showRequired = true,
    disabled,
    children,
    hasPermission,
    txUserDisabled,
    showTxCenterORDateTimeFields = true,
    showWarningNotification = false,
    serviceType,
  }: CaseTxCenterProps) => {
    const { control } = useFormContext<CaseTxCenterFormType>();

    return (
      <>
        <FormRow multiRow title="TX Center" isRequired={showRequired}>
          <div className="w-full flex flex-col gap-3">
            <TxCenterSelector disabled={disabled} hasPermission={hasPermission} />
            <CaseTxContacts hasPermission={hasPermission} serviceType={serviceType} txUserDisabled={txUserDisabled} />
          </div>
        </FormRow>
        <ConditionalRender show={showTxCenterORDateTimeFields}>
          <DateTimePickerInputs
            disabledPast
            control={control}
            title="TX Center OR"
            dateFieldName="recipientHospitalDate"
            dateFieldLabel="Select OR Date"
            timeFieldName="recipientHospitalTime"
            timeFieldLabel="Select OR Time"
            timeZoneFieldName="recipientHospitalTimeZone"
            hasPermission={hasPermission}
          />
        </ConditionalRender>
        {children}
        <CaseTxCenterBanners showWarningNotification={showWarningNotification} serviceType={serviceType} />
      </>
    );
  },
);
